module.exports = __webpack_public_path__ + "img/Yellow.f5a17a95.svg";